import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Porque from "@/components/Porque";
import CoberturaNacional from "@/components/CoberturaNacional";
import Stats from "@/components/Stats";
import NewsBanner from "@/components/NewsBanner";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({ pageKey: "home" });
  return (
    <>

      <Hero />
      <Marquee />
      <Porque />
      <CoberturaNacional />
      <Stats />
      <NewsBanner />
    </>
  );
}
